import ATableAccess from "./aTableAccess";

class ProjectAccess extends ATableAccess {}

export default ProjectAccess;
